module.exports = __webpack_public_path__ + "static/media/fangfanghentiaoshi.d8551ad3.png";